export class BaseRateModel {
    productId: string;
    currencyCode: string;
    partnerId: string;
    constructor(productId: string, currencyCode: string, partnerId: string) {
        this.productId = productId;
        this.currencyCode = currencyCode;
        this.partnerId = partnerId;
    }
}
export class BaseRateResponseModel {
    baseRateInINR: number;
    cardRateInINR: number;
    currencyCode: string;
    nrr: number;
    revenueModel: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/rates/BaseRateModel.ts